/**
 * Cloudinary delivery URL helpers (f_auto / q_auto / width caps).
 */

const CLOUDINARY_BASE = "https://res.cloudinary.com/dhbe6wtod";

/**
 * @param {string} publicIdPath - e.g. "v1773667382/werkix/home/Werkix2_jrzyue"
 * @param {object} opts
 * @returns {string}
 */
export const cloudinaryVideoUrl = (publicIdPath, opts = {}) => {
  const { width = 1280, quality = "auto:eco" } = opts;
  const transforms = [`w_${width}`, `q_${quality}`, "f_mp4", "vc_h264"].join(",");
  return `${CLOUDINARY_BASE}/video/upload/${transforms}/${publicIdPath}.mp4`;
};

/**
 * @param {string} publicIdPath - path after /upload/ including version folder
 * @param {object} opts
 * @returns {string}
 */
export const cloudinaryImageUrl = (publicIdPath, opts = {}) => {
  const { width = 1600, quality = "auto:good" } = opts;
  const transforms = [`w_${width}`, `q_${quality}`, "f_auto"].join(",");
  return `${CLOUDINARY_BASE}/image/upload/${transforms}/${publicIdPath}`;
};

export const BANNER_VIDEO_URL = cloudinaryVideoUrl(
  "v1773667382/werkix/home/Werkix2_jrzyue"
);
